import React, { useState } from 'react'

function PreviewExcelKaryawan({ sheets }) {
    const [activeSheet, setActiveSheet] = useState(0)

    if (!sheets || sheets.length === 0) return null

    const { cols, rows } = sheets[activeSheet]

    return (
        <>
            <div className='sheet-tabs'>
                {sheets.map((sheet, idx) => (
                    <button
                        key={idx}
                        onClick={() => setActiveSheet(idx)}
                        className={idx === activeSheet ? 'active' : ''}
                    >
                        {sheet.name}
                    </button>
                ))}
            </div>

            <div className='table-wrapper'>
                <table>
                    <thead>
                        <tr>
                            {cols.map((col, i) => (
                                <th key={i}>{col}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rIdx) => (
                            <tr key={rIdx}>
                                {cols.map((_, cIdx) => (
                                    <td key={cIdx}>
                                        {row[cIdx] !== undefined && row[cIdx] !== null ? String(row[cIdx]) : ''}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default PreviewExcelKaryawan
